export const OriginType = {
  TD: 'Tienda',
  CD: 'Centro de Distribución',
  PRV: 'Proveedor',
  SELLER: 'SELLER',
};
